import React, { useState } from 'react';
import axios from 'axios';
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  useToast,
  Link
} from '@chakra-ui/react';
import { setToken, setRefreshToken, setUserType, setAccountId } from '../utils/authService';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import { generateToken } from '../notifications/firebase';  // Import the generateToken function


const LoginPage = ({ setIsLoggedIn }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const toast = useToast();
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const backendUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_BACKEND_URL
        : 'http://localhost:8080';
      const response = await axios.post(`${backendUrl}/login`, { email, password });
      const { token, refresh_token, account_id, user_type } = response.data;
      setToken(token);
      setRefreshToken(refresh_token);
      setIsLoggedIn(true);
      setUserType(user_type);
      setAccountId(account_id);
      navigate('/search');
      toast({
        title: 'Login successful!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error during login:', error);
      toast({
        title: 'Login failed.',
        description: 'Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const bgColor = useColorModeValue('white', 'black');
  const textColor = useColorModeValue('black', 'white');
  const headingColor = useColorModeValue('black', 'white');

  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bg={bgColor}>
      <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
        <Stack align={'center'}>
          <Heading fontSize={'4xl'} color={headingColor}>Sign in to your account</Heading>
          <Text fontSize={'lg'} color={'gray.600'}>
            to enjoy all of our cool <Text as="span" color={'blue.400'}>features</Text> ✌️
          </Text>
        </Stack>
        <Box
          rounded={'lg'}
          bg={bgColor}
          boxShadow={'lg'}
          p={8}>
          <Stack spacing={4} as="form" onSubmit={handleLogin}>
            <FormControl id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>
            <Stack spacing={10}>
              <Stack
                direction={{ base: 'column', sm: 'row' }}
                align={'start'}
                justify={'space-between'}>
                <Checkbox>Remember me</Checkbox>
                <Link color={'blue.400'} onClick={() => navigate('/forgot-password')}>
                  Forgot password?
                </Link>
              </Stack>
              <Button
                bg={'blue.400'}
                color={'white'}
                type="submit"
                _hover={{
                  bg: 'blue.500',
                }}>
                Sign in
              </Button>
              <Text align={'center'}>
                Not a user? <Link color={'blue.400'} href='/onboarding'>Sign Up</Link>
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
};

export default LoginPage;
